import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

import { ArangoService } from '../../services/arangoservice/arango.service';
import { Observable, of, Subscription } from 'rxjs';
import { Person } from '../../bo9-shared/models/person/person.model';
import { validationMessages } from '../../helpers/form.helper';
import { contactFullName } from '../../bo9-shared/models/contact/contact.model';
import { Invite } from '../../bo9-shared/models/person/invite.model';
import { MatTableDataSource} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator} from '@angular/material/paginator';
import { SearchService } from '../../services/search/search.service';
import { PaneType } from '../../displayComponents/slide-panel/slide-panel.component';

export interface Invites {
  from: string,
  to: string,
  email: string,
  Invite: string,
  pearlmodule: string,
  naturalnumber: string,
  source: string
}
@Component({
    selector: 'app-invites',
    templateUrl: './invites.component.html',
    styleUrls: ['./invites.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvitesComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public displayedColumns = ['from','to',  'email', 'invite', 'pearlmodule', 'naturalnumber','source', 'delete'];
  public dataSource = new MatTableDataSource<Invites>();
  messagesLoading$: Observable<boolean>;

  currentPane:PaneType = PaneType.center;
  valid: false;

  directionLinks: boolean = true;
  autoHide: boolean = false;
  responsive: boolean = true;

  searchString: string;

  currentP$: Observable<Person>;
  currentPerson: Person;
  InviteForm: FormGroup;

  invites: Invites[] =[];
  user: Person;

  validationMessages = validationMessages;

  Invites$: Observable<Invite[]>;
  PearlModuleTypes$: Observable<string[]>;
  subscriptions: Subscription[] = [];
  constructor(
    private auth: AuthService,
    private router: Router,
    private arangoService: ArangoService,
    private searchService: SearchService
    ) 
  {
    this.currentPane = PaneType.center;
    this.user = this.auth.getAuthUser()!;
    this.subscriptions.push(this.arangoService.recordVisit({
      page: this.router.url, component: 'InvitesComponent', 
      visitor: this.user._key,
      help: false
    }).subscribe ({next: () => {}})); 
      if (!this.user) {
        console.error('User Not logged in ');
        alert('EMail support&#64;bodyof9.com - Permission  Error #021'); 
        this.router.navigate(['login'] );
      }  
  }

  
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

  }

  ngOnInit() {

  }

  onPageChange(event:any){
    console.log(event);
  }

  onClickSearch() {
    // this.arangoService.search(this.searchString, (this.pageNum -1)* this.pageSize, this.pageSize)
    this.searchService.search(this.searchString, [],[],0, 100)
    .subscribe( (res: any) => {

    })
  }

  onCloseClick() {
    this.currentPane = PaneType.center;
  }



  onClickExpand(p:Person) {
    console.log('Expand Person  Contact '+ JSON.stringify(p.contact));
    this.currentP$ = of(p);

    this.currentPane = PaneType.right;
  }

  personSubmittedHandler($event: any) {
    console.log(' Person  submitted '+ JSON.stringify($event));
    this.currentPane = PaneType.center;
  }

  relateSubmittedHandler($event: any) {
    console.log(' Relate  submitted '+ JSON.stringify($event));
    this.currentPane = PaneType.center;
  }

}
